import { useNavigate } from "react-router-dom";
import './header.css';
import { useContext } from "react";
import { ShopContext } from "../../../Context/ShopContext";

const Header = () => {
    const storedUser = JSON.parse(sessionStorage.getItem('userData'));
    const navigate = useNavigate();
    const {
        setToggleMenu
    } = useContext(ShopContext);

    const onLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/')
    }

    return (
        <nav className="navbar navbar-expand navbar-dark sticky-top py-3 admin-navbar right-content-section">
            <div className="navbar-nav align-items-center admin_header_menus w-100 justify-content-md-end justify-content-between">
                <button className="mobile-toggle-btn" onClick={()=>setToggleMenu(true)}>
                    <i className="fi fi-rr-menu-burger"></i>
                </button>
                <div className="admin_dropdown">
                    <button className="admin_dropdown-button d-flex align-items-center gap-2">
                        <span className="admin_profile_icon d-flex align-items-center justify-content-center user_icon_header">
                              <i className="fas fa-user"></i>
                            {storedUser?.name}
                        </span>
                        <span>
                            <svg id="Layer_2" height="25" viewBox="0 0 512 512" width="25" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" data-name="Layer 2" version="1.1" xmlnssvgjs="http://svgjs.dev/svgjs">
                                <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                                    <linearGradient id="linear-gradient" gradientUnits="userSpaceOnUse" x1="43.95" x2="468.05" y1="43.95" y2="468.05">
                                        <stop stopOpacity="0" stopColor="#ffffff" offset="1" />
                                        <stop stopOpacity="1" stopColor="#0043ae" offset="1" />
                                    </linearGradient>
                                    <g id="Icon">
                                        <g id="_135" data-name="135">
                                            <path id="BG" d="m512 150v212c0 82.8-67.2 150-150 150h-212c-82.8 0-150-67.2-150-150v-212c0-82.8 67.2-150 150-150h212c82.8 0 150 67.2 150 150z" fill="url(#linear-gradient)" stroke="none" strokeOpacity="1" />
                                            <path d="m416 192h-96l-64 64-64-64h-96l160 160z" fill="#000000" fillOpacity="1" stroke="none" strokeOpacity="1" />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </button>
                    <div className="admin_dropdown-content">
                        {/* <Link to="/myprofile" className="dropdown-item profile-dropdown-item">My Profile</Link> */}
                        <span onClick={onLogout} className="dropdown-item profile-dropdown-item" style={{ cursor: 'pointer' }}>Log Out</span>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Header;